<template lang="html">
  <div class="payments-wrapper">
    <portal target-el="#filter">
      <PayFilter :options="orderCategory"
        @changeDate="changeDate"
        @change="mainOptionChange"
        @invoiceFilterChange="invoiceFilterChange"
        :indentFilters="indentFilters"
        :invoiceFilters="invoiceFilters"
        :seletedIndentType="seletedIndentType"
        :seletedVehicleType="seletedVehicleType"
        :selectedInvoiceType="selectedInvoiceType"
        :vehicleTypes="vehicleTypes"
        :seletedOption="selectedOption"
        :showPayment="showPayment"
        :canCreateInvoice="canCreateInvoice"
        @searchPayment="searchPayment"
        @searchInvoice="searchInvoice"
        @exportInvoices="exportInvoices"
        @depotFilterChange="depotFilterChange"
        @indentFilterChange="indentFilterChange"
        @vehicleFilterChange="vehicleFilterChange"
        :defaultDepot="selectedDepot"
        :depotList="depots" />
      <SubFilter v-if="!showPayment" @statusChange="statusChange"
        @filterByDate="filterByDate"/>
    </portal>
    <Payment v-if="showPayment"
      :loadCheck="isEmptyPaginate"
      :selectedDepot="selectedDepot"
      @select="select"
      @loadData="loadData"/>
    <Invoice v-else :daterange="daterange"
      :status="status"
      @loadData="loadData"
      :loadCheck="isEmptyPaginate"/>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Payment from '@/components/payment/list/payment';
import Invoice from '@/components/payment/Invoice/list/Invoice';
import SubFilter from '@/components/payment/list/SubFilter';
import downloadFile from '@common/utils/downloadFile';
import {
  indentFilters,
  vehicleTypes,
  invoiceFilters,
} from '@/constants/payments';
import PayFilter from '../../common/payFilter';
import orderCategory from '../../../constants/order-catergory';

export default {
  components: { PayFilter, Payment, SubFilter, Invoice },

  data() {
    const selectedOption = this.$store.invoiceSelectedOption
      ? this.$store.invoiceSelectedOption
      : orderCategory[0];
    return {
      filter: {
        status: null,
        client_id: null,
        end: null,
        start: null,
        depot_id: null,
        page: null,
      },
      filterInvoice: {
        client_id: null,
        end: null,
        start: null,
        depot_id: null,
        page: null,
      },
      selectedAll: false,
      orderCategory,
      canCreateInvoice: false,
      selectedOption,
      selectedDepot: null,
      daterange: null,
      status: null,
      indentFilters,
      invoiceFilters,
      vehicleTypes,
    };
  },

  computed: {
    showPayment() {
      return this.selectedOption.id === 0;
    },

    ...mapGetters({
      clients: 'app/clients',
      depots: 'app/depots',
      isPaginating: 'payment/isPaginating',
      isEmptyPaginate: 'payment/isEmptyPaginate',
      isLoading: 'payment/isLoading',
      isInvoiceLoading: 'payment/isInvoiceLoading',
    }),

    ...mapState({
      invoiceFilter: state => state.payment.invoiceFilter,
      seletedIndentType: state => state.payment.indentType,
      seletedVehicleType: state => state.payment.vehicleType,
      selectedInvoiceType: state => state.payment.invoiceType,
    }),

    currentClient() {
      return this.clients[0];
    },
  },

  async created() {
    if (this.depots && this.depots.length) {
      const lastSelectedDepot = this.depots.find(depot => depot.id === localStorage.paymentDefaultDepot);
      this.selectedDepot = (lastSelectedDepot ? lastSelectedDepot.id : this.depots[0].id);
      this.filter.depot_id = this.selectedDepot;
    }
    this.filter.client_id = this.currentClient.id;
    this.filter.page = 1;
    this.filterInvoice.client_id = this.currentClient.id;
    this.filterInvoice.page = 1;
  },
  methods: {
    async loadData() {
      if (this.selectedOption.id == 0) {
        if (!this.isLoading) {
          this.filter.page = this.filter.page + 1;
          const params = this.serializeObject(this.filter);
          await this.$store.dispatch('payment/paginate', { params });
        }
      } else if (!this.isInvoiceLoading) {
        this.filterInvoice.page = this.filterInvoice.page + 1;
        const params = this.serializeObject(this.filterInvoice);
        await this.$store.dispatch('payment/paginateInvoice', { params });
      }
    },

    async searchPayment(query) {
      const splitedData = query.split(',');
      const cleanedData = [];
      splitedData.forEach((element) => {
        cleanedData.push(element.trim());
      });
      this.filter.search = cleanedData.filter(Boolean);
      const params = this.serializeObject(this.filter);
      await this.$store.dispatch('payment/filter', params);
    },

    searchInvoice(query) {
      const splitedData = query.split(',');
      const cleanedData = [];
      splitedData.forEach((element) => {
        cleanedData.push(element.trim());
      });
      this.filterInvoice.search = cleanedData.filter(Boolean);
      const params = this.serializeObject(this.filterInvoice);
      this.$store.dispatch('payment/filterInvoice', params);
    },

    createInitData() {
      this.filter.depot_id = this.selectedDepot;
      this.filter.client_id = this.currentClient.id;
      this.filter.page = 1;
      // this.filterInvoice.depot_id = this.selectedDepot;
      this.filterInvoice.client_id = this.currentClient.id;
      this.filterInvoice.page = 1;
      this.filterInvoice.type = null;
      this.$store.commit('payment/initData');
    },

    invoiceFilterChange(type) {
      this.createInitData();
      if (type.id) {
        this.filterInvoice.type = type.id;
      }
      const params = this.serializeObject(this.filterInvoice);
      this.$store.dispatch('payment/filterInvoice', params);
    },
    indentFilterChange(type) {
      this.filter.type = type.id;
      this.$store.commit('payment/setIndentFilter', type);
      this.changeDate();
    },
    vehicleFilterChange(deliveryType) {
      this.createInitData();
      this.seletedVehicleType = deliveryType;
      this.$store.commit('payment/setdeliveryType', deliveryType);
      this.changeDate();
    },

    async changeDate(data = {}) {
      this.filter = {
        start: null,
        end: null,
        client_id: this.currentClient.id,
        delivery_type: null,
      };
      this.createInitData();
      if (data.start && data.end) {
        const startDate = new Date(`${data.start}`).setHours(0, 0, 0, 0);
        const endDate = new Date(`${data.end}`).setHours(23, 59, 59, 999);
        this.filter.start = new Date(startDate).toISOString();
        this.filter.end = new Date(endDate).toISOString();
      }
      if (this.seletedIndentType.id) {
        this.filter.filter_type = this.seletedIndentType.id;
      }
      if (this.seletedVehicleType.id) {
        this.filter.delivery_type = this.seletedVehicleType.id;
      }
      if (this.selectedDepot) {
        this.filter.depot_id = this.selectedDepot;
      }
      const params = this.serializeObject(this.filter);
      await this.$store.dispatch('payment/filter', params);
      this.$store.payments = {
        selected: [],
      };
    },
    depotFilterChange(depot) {
      this.selectedDepot = depot;
      localStorage.paymentDefaultDepot = depot;
      this.changeDate();
    },
    selectall(status) {
      this.selectedAll = status;
    },
    select() {
      const {
        $store: {
          payments: { selected },
        },
      } = this;
      if (selected.length > 0) {
        this.canCreateInvoice = true;
      } else {
        this.canCreateInvoice = false;
      }
    },
    serializeObject(data) {
      const result = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach((key) => {
        if (data[key] !== null && data[key] !== '') {
          result[key] = data[key];
        }
      });
      return result;
    },
    mainOptionChange(option) {
      this.createInitData();
      this.selectedOption = option;
      this.$store.invoiceSelectedOption = option;
    },
    statusChange(status) {
      if (status.id === 0) {
        this.status = null;
        this.filterInvoice.page = 1;
        this.filterInvoice.status = null;
      } else {
        this.status = status;
        this.filterInvoice.page = 1;
        this.filterInvoice.status = status.name;
      }
    },
    filterByDate(date) {
      this.daterange = date;
    },
    async exportInvoices() {
      const filterparamns = this.filterInvoice;
      filterparamns.page = null;
      let params = this.serializeObject(filterparamns);
      if (this.status) {
        params = Object.assign({}, params, { status: this.status.name });
      }
      const result = await this.$store.dispatch('payment/exportInvoice', params);
      if (result.type === 'application/json') {
        this.$infoMessage({ message: this.$getSuccess('EXPORT_VIA_EMAIL') });
      } else if (result.error) {
        this.$errorMessage({ message: this.$getErr(503) });
      } else {
        const url = window.URL.createObjectURL(new Blob([result]));
        const now = new Date().toISOString();
        downloadFile(document, url, `Invoice-${now}.xlsx`);
      }
    },
    depotList() {
      return this.depots;
    },
  },
};
</script>
